import React from 'react';
import { LinearProgressOverlay } from '@campfire/linear-progress-overlay';
import { Box, Grid, Typography } from '@material-ui/core';
import { HoverText } from '@campfire/hover-link';
import { useCampfireTheme } from '../../../theme/useCampfireTheme';
import { useSnackbar } from '../../../global/config/useSnackbar';
import { useResendVerifyEmailFetch } from './CreateTrialAccountActions';

export const VerifyEmailPrompt = ({ firstName, email }: { firstName: string; email: string }) => {
  const { isMobile, theme } = useCampfireTheme();

  const resendVerifyEmailFetch = useResendVerifyEmailFetch();
  const { isLoading } = resendVerifyEmailFetch;
  const { setSnackbar } = useSnackbar();

  const runResendVerifyEmail = () => {
    resendVerifyEmailFetch
      .run({ email: email })
      .then((response) => {
        if (!response.ok) {
          setSnackbar({
            open: true,
            message: 'Unable to resend email',
            variant: 'error',
          });
          return;
        }

        setSnackbar({
          open: true,
          message: 'Email sent',
          variant: 'success',
        });
      })
      .catch(() => {
        setSnackbar({
          open: true,
          message: 'Unable to resend email',
          variant: 'error',
        });
      });
  };

  return (
    <>
      <LinearProgressOverlay isLoading={isLoading} opacity={0} />
      <Box paddingTop={8} paddingBottom={isMobile ? 0 : 8} position='relative'>
        <Grid justify='center' container style={{ flexGrow: 1 }}>
          <Grid item xs={12} sm={10} style={{ textAlign: 'center', paddingLeft: 24, paddingRight: 24 }}>
            <Typography variant='h4' style={{ color: '#343434' }}>
              Please verify your email
            </Typography>
            <Typography variant='h6' gutterBottom style={{ color: theme.color.grey.neutralBrand400 }}>
              {firstName ? `Last step, ${firstName}!` : 'Nearly there'}
            </Typography>
            <Typography component='span' variant='body2' color='textSecondary' style={{ marginTop: 16 }}>
              {`Check your inbox for an email from `}
              <b>
                <i>{`postman@volaby.org`}</i>
              </b>
              {`. If you can't find anything in your inbox or junk, you can `}
              <HoverText
                display='inline'
                variant='body2'
                color='primary'
                hoverColor='primary'
                onClick={() => runResendVerifyEmail()}
              >
                {'click here to resend.'}
              </HoverText>
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
